<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Compartilhar Documentos"
  description="Gerencie e compartilhe seus documentos com empresas">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Seção: Meus Compartilhamentos -->
  @if(user?.cpf){
  <section class="mb-xl">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Meus Compartilhamentos</h3>
      </div>
      <div class="card-body">
        <p class="text-secondary mb-md">Empresas com acesso aos seus documentos:</p>
        <app-document-sharing [owner]="user!.cpf"></app-document-sharing>
      </div>
    </div>
  </section>
  }

  <!-- Compartilhar com Nova Empresa -->
  <section class="mb-xl">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Compartilhar com Nova Empresa</h3>
      </div>
      <div class="card-body">



        <!-- Aviso LGPD -->
        <div class="alert alert-warning mb-lg">
          <span>⚠</span>
          <div>
            <strong>Aviso de Privacidade:</strong>
            <p>Ao compartilhar documentos, você está aceitando as regras de LGPD e concorda que a empresa poderá acessar
              os documentos compartilhados.</p>
          </div>
        </div>

        <!-- Formulário de Busca -->
        <div class="card card-white mb-lg searchCompany">
          <div class="input-group">
            <input #cnpj [showMaskTyped]="true" mask="00.000.000/0000-00" placeholder="Digite o CNPJ da empresa"
              class="input" />
            <button class="btn btn-primary" (click)="searchCompany(cnpj.value); cnpj.value = ''">
              Pesquisar
            </button>
          </div>
          <!-- Informações -->
          <div class="alert alert-info mb-lg">
            <span>ℹ</span>
            <div>
              <p><strong>Como funciona:</strong></p>
              <p>1. Informe o CNPJ da empresa cadastrada no sistema</p>
              <p>2. A empresa receberá notificação para acessar seus documentos</p>
              <p>3. Apenas documentos marcados como compartilháveis serão visíveis</p>
              <p>4. A empresa será notificada sobre documentos próximos do vencimento</p>
            </div>
          </div>
        </div>

        <!-- Resultado da Busca -->
        @if(sharedCompany){
        <div class="file-container">
          <div class="file-card">
            <div class="file-icon">
              <mat-icon>business_center</mat-icon>
            </div>
            <div class="file-info">
              <h4 class="file-title">{{ sharedCompany.companyName }}</h4>
              <p class="file-name">CNPJ: {{ sharedCompany.cnpj }}</p>
              <div class="file-meta">
                <span class="badge badge-success">Empresa Encontrada</span>
              </div>
            </div>
            <div>
              <button mat-raised-button color="primary" (click)="shareDocuments()">
                <mat-icon>share</mat-icon>
                Compartilhar
              </button>
            </div>
          </div>
        </div>
        }

      </div>
    </div>
  </section>

</div>
}